import React from 'react'

import { Button, Modal, Form, Col, Row } from '_zari/core'
import { ZariContext } from '_zari/context'

import * as ActivosFijosService from 'services/activosFijos.service'

// Repotenciación y mejora comparten formulario: ambas capitalizan sobre el activo. La única
// diferencia es que la repotenciación puede recalcular la tasa de depreciación.
const CapitalizacionActivoModal = ({ handleClose, show, activo, tipo, onRegistrado }) => {
  const __zariContext = React.useContext(ZariContext)

  const esRepotenciacion = tipo === 'REPOTENCIACION'
  const titulo = esRepotenciacion ? 'REPOTENCIACION' : 'MEJORA'

  const [fecha, setFecha] = React.useState('')
  const [descripcion, setDescripcion] = React.useState('')
  const [monto, setMonto] = React.useState('')
  const [depreciacionAnual, setDepreciacionAnual] = React.useState('')
  const [documentoSustento, setDocumentoSustento] = React.useState('')
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const valorActual = parseFloat(activo.valorAdquisicion || 0)
  const montoNumero = parseFloat(monto || 0)
  const valorResultante = montoNumero > 0 ? valorActual + montoNumero : valorActual

  const submitHandler = async () => {
    setIsSubmitting(true)
    try {
      const payload = {
        fecha: fecha,
        descripcion: descripcion,
        monto: montoNumero,
        documentoSustento: documentoSustento || undefined
      }
      if (esRepotenciacion && depreciacionAnual !== '') {
        payload.depreciacionAnual = parseFloat(depreciacionAnual)
      }

      const servicio = esRepotenciacion
        ? ActivosFijosService.registrarRepotenciacion
        : ActivosFijosService.registrarMejora

      await servicio(activo._id, payload)
      __zariContext.snack('success', `${titulo} registrada.`)
      if (onRegistrado) onRegistrado()
      handleClose()
    } catch (err) {
      const error = err && err.data && err.data.error
      __zariContext.snack('error', error || `No se pudo registrar la ${titulo.toLowerCase()}.`)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>{titulo}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label text='CODIGO' md={12} />
              <Col md={12}>
                <Form.InputText id='readonly-cap-codigo' disabled defaultValue={activo.codigo} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group>
              <Form.Label text='DESCRIPCION' md={12} />
              <Col md={12}>
                <Form.InputText id='readonly-cap-descripcion' disabled defaultValue={activo.descripcion} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='FECHA' htmlFor='input-cap-fecha' md={12} />
              <Col md={12}>
                <Form.InputDate
                  id='input-cap-fecha'
                  value={fecha}
                  disabled={isSubmitting}
                  onChange={e => setFecha(e.target.value)}
                />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='MONTO' htmlFor='input-cap-monto' md={12} />
              <Col md={12}>
                <Form.InputNumber
                  id='input-cap-monto'
                  step='0.01'
                  value={monto}
                  disabled={isSubmitting}
                  onChange={e => setMonto(e.target.value)}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group>
          <Form.Label text='DESCRIPCION DEL MOVIMIENTO' htmlFor='input-cap-desc' md={3} />
          <Col md={9}>
            <Form.InputText
              id='input-cap-desc'
              value={descripcion}
              disabled={isSubmitting}
              onChange={e => setDescripcion(e.target.value)}
            />
          </Col>
        </Form.Group>
        <Form.Group>
          <Form.Label text='DOCUMENTO SUSTENTO' htmlFor='input-cap-doc' md={3} />
          <Col md={9}>
            <Form.InputText
              id='input-cap-doc'
              value={documentoSustento}
              disabled={isSubmitting}
              onChange={e => setDocumentoSustento(e.target.value)}
            />
          </Col>
        </Form.Group>
        {esRepotenciacion && (
          <Form.Group>
            <Form.Label text='NUEVA DEPREC. ANUAL %' htmlFor='input-cap-dep' md={3} />
            <Col md={9}>
              <Form.InputNumber
                id='input-cap-dep'
                step='0.01'
                value={depreciacionAnual}
                disabled={isSubmitting}
                onChange={e => setDepreciacionAnual(e.target.value)}
              />
              <div className='text-muted small mt-1'>
                {`Opcional. Actual: ${activo.depreciacionAnual || 0}%. Solo si la repotenciación alarga la vida útil.`}
              </div>
            </Col>
          </Form.Group>
        )}
        <div className='text-muted small'>
          {`Valor del activo: ${valorActual.toFixed(2)} → ${valorResultante.toFixed(2)}`}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' disabled={isSubmitting} onClick={handleClose}>
          Cancelar
        </Button>
        <Button disabled={isSubmitting} onClick={submitHandler}>
          Registrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CapitalizacionActivoModal
